import { useState } from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { AuthLayout } from '../components/Layout/AuthLayout';
import { Input } from '../components/common/Input';
import { Button } from '../components/common/Button';

import './Auth.css';

export function Login() {
  usePageTitle('Entrar');
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(formData);
    } catch (err: any) {
      setError(err.message || 'Falha ao fazer login. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout currentStep={1}>
      <div className="auth-page">
        <div className="auth-header">
          <h2 className="auth-title">Bem-vindo de volta</h2>
          <p className="auth-subtitle">Insira suas credenciais para acessar sua conta.</p>
        </div>

        {error && (
          <div style={{
            backgroundColor: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid rgba(239, 68, 68, 0.2)',
            color: '#f87171',
            padding: 'var(--space-3)',
            borderRadius: 'var(--radius-md)',
            marginBottom: 'var(--space-4)',
            fontSize: 'var(--text-sm)',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form className="auth-form" onSubmit={handleSubmit}>
          <Input 
            label="E-mail" 
            name="email" 
            type="email" 
            placeholder="ex. joao@empresa.com.br" 
            value={formData.email}
            onChange={handleChange}
            required 
            disabled={loading}
          />
          
          <Input 
            label="Senha" 
            name="password" 
            type="password" 
            placeholder="Digite sua senha" 
            value={formData.password}
            onChange={handleChange}
            required 
            disabled={loading}
          />

          <div style={{ textAlign: 'right', marginBottom: 'var(--space-6)', marginTop: '-var(--space-2)' }}>
            <Link to="/forgot-password" style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-secondary)' }}>
              Esqueceu a senha?
            </Link>
          </div>

          <Button type="submit" variant="secondary" fullWidth disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>



        <div className="auth-footer">
          Não tem uma conta? <Link to="/register">Cadastre-se</Link>
        </div>
      </div>
    </AuthLayout>
  );
}
